// theme.js

const productImages = document.querySelectorAll('.product-image');  
productImages.forEach(image => {  
    image.addEventListener('mousemove', (e) => {  
        const rect = image.getBoundingClientRect();  
        const x = ((e.clientX - rect.left) / rect.width) * 100;  
        const y = ((e.clientY - rect.top) / rect.height) * 100;  
        image.style.transformOrigin = `${x}% ${y}%`;  
        image.style.transform = 'scale(2)';  
    });  
    image.addEventListener('mouseleave', () => {  
        image.style.transform = 'scale(1)';  
        image.style.transformOrigin = 'center center';  
    });  
});

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

// Auto-submit form when desktop sort option is selected
document.addEventListener('DOMContentLoaded', function() {
  const desktopSortInputs = document.querySelectorAll('.sort-dropdown input[type="radio"][name="sort_by"]');
  desktopSortInputs.forEach(input => {
    input.addEventListener('change', function() {
      const form = this.closest('form');
      if (form) {
        form.submit();
      }
    });
  });
});

// Offcanvas Menu

(() => {
  const nav = document.getElementById('ocNav');
  if (!nav) return;

  const panelsWrap = nav.querySelector('.oc-panels');
  const panels = () => Array.from(panelsWrap.querySelectorAll('.oc-panel'));

  const root = panelsWrap.querySelector('.oc-panel[data-oc-root="true"]') || panelsWrap.querySelector('.oc-panel');
  if (!root) return;

  let stack = [root];

  function showPanel(next) {
    const current = stack[stack.length - 1];
    if (current === next) return;

    current.classList.remove('is-active');
    current.classList.add('is-left');

    next.classList.add('is-active');

    stack.push(next);
  }

  function goBack() {
    if (stack.length <= 1) return;

    const current = stack.pop();
    const prev = stack[stack.length - 1];

    current.classList.remove('is-active');
    current.classList.remove('is-left'); // reset state for next open
    prev.classList.add('is-active');
    prev.classList.remove('is-left');
  }

  function reset() {
    stack = [root];
    panels().forEach((p) => {
      p.classList.remove('is-left', 'is-active');
    });
    root.classList.add('is-active');
  }

  nav.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-oc-toggle]');
    if (toggle) {
      e.preventDefault();
      const id = toggle.getAttribute('data-oc-toggle');
      const next = document.getElementById(id);
      if (!next) return;

      // Update aria on the clicked toggle
      toggle.setAttribute('aria-expanded', 'true');

      showPanel(next);
      return;
    }

    const back = e.target.closest('[data-oc-back]');
    if (back) {
      e.preventDefault();
      goBack();
      return;
    }
  });

  // Reset when Bootstrap offcanvas closes (recommended)
  const offcanvasEl = nav.closest('.offcanvas');
  if (offcanvasEl) {
    offcanvasEl.addEventListener('hidden.bs.offcanvas', reset);
  }
})();